import { fetchOk } from '@atlassian/mpac-fetch-wrapper';

/* Get list of Contacts for a Partner */
export const getPartnerContacts = (mpacBaseUrl, partnerId, queryParams) => {
  // URLSearchParams expects all params to be a string
  const stringifiedParams = {};
  Object.keys(queryParams).map(key => stringifiedParams[key] = queryParams[key].toString());
  const params = new URLSearchParams(stringifiedParams);
  return fetchOk("".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/contacts?").concat(params.toString())).then(response => response.json());
};
export const deletePartnerContact = (mpacBaseUrl, contactResource) => fetchOk("".concat(mpacBaseUrl).concat(contactResource), {
  method: 'DELETE'
});
export const addNewContact = (mpacBaseUrl, partnerId, contact) => {
  return fetchOk("".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/contacts"), {
    method: 'POST',
    body: JSON.stringify(contact),
    headers: {
      'Content-Type': 'application/json'
    }
  });
};
export const patchPartnerContact = (mpacBaseUrl, contactResource, contact) => fetchOk("".concat(mpacBaseUrl).concat(contactResource), {
  method: 'PATCH',
  body: JSON.stringify(contact),
  headers: {
    'Content-Type': 'application/json-patch+json'
  }
});